import { useEffect, useState } from 'react';

export function formatDuration(seconds: number): string {
  const hrs = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, '0');
  const mins = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');

  // if hours are 0, return only minutes and seconds
  if (hrs === '00') {
    return `${mins}:${secs}`;
  }

  return `${hrs}:${mins}:${secs}`;
}

export function useDuration(start = true) {
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (!start) return;

    const interval = setInterval(() => {
      setDuration(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [start]);

  return duration;
}
